import React from 'react';

export default function LendingTermsFr() {
  return (
    <div className="doc-page">
      <div className="doc-header">
        <span className="doc-label">Prêt</span>
        <h1 className="doc-title">Conditions de prêt salarial de MegaTransact</h1>
        <p className="doc-intro">
          MegaTransact commence par le prêt salarial en tant que forme structurée de soutien
          financier lié au lieu de travail. Les présentes conditions de prêt salarial s'appliquent
          en complément des conditions générales d'utilisation de MegaTransact et de la politique
          de confidentialité de MegaTransact.
        </p>
        <div className="doc-meta">
          <span className="doc-meta-item">
            <strong>Date d'entrée en vigueur :</strong> 27 mars 2026
          </span>
          <span className="doc-meta-item">
            <strong>Dernière mise à jour :</strong> 27 mars 2026
          </span>
        </div>
      </div>

      <div className="doc-body">
        <div className="doc-preamble">
          <p>
            Les présentes conditions de prêt salarial régissent votre accès et votre utilisation
            du service de prêt salarial de MegaTransact. En faisant une demande, en acceptant ou
            en utilisant ce service, vous acceptez les présentes conditions.
          </p>
          <p>
            En cas d'incohérence entre les présentes conditions de prêt salarial et les conditions
            générales d'utilisation de MegaTransact, les présentes conditions de prêt salarial
            prévaudront pour le service de prêt dans la mesure de cette incohérence.
          </p>
        </div>

        {/* Section 1 */}
        <div className="doc-section">
          <span className="section-number">Section 1</span>
          <h2 className="section-title">Qui sommes-nous</h2>
          <p>
            MegaTransact est une plateforme numérique conçue pour fournir un soutien financier
            structuré lié au salaire et des services numériques connexes.
          </p>
          <p>Pour toute question concernant les présentes conditions de prêt salarial, vous pouvez nous contacter à :</p>
          <div className="doc-contact-box">
            <p>
              <strong>E-mail :</strong>{' '}
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
            <p>
              <strong>Société :</strong> MegaBliss LTD
            </p>
            <p>
              <strong>Adresse :</strong> Bâtiment EIFUN, Avenue Kabalo n° 171, croisement Huilerie-Kabalo, Kinshasa, 4ᵉ niveau, bureau n° 45
            </p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="doc-section">
          <span className="section-number">Section 2</span>
          <h2 className="section-title">Nature du service</h2>
          <p>
            Le service de prêt salarial de MegaTransact est un service lié au lieu de travail par
            lequel les utilisateurs éligibles peuvent demander un soutien financier à court terme
            soumis à examen, approbation et conditions de remboursement.
          </p>
          <p>
            Ce service est structuré autour d'arrangements de remboursement liés au salaire et
            peut impliquer la coopération de l'employeur, le calendrier de paie et des processus
            connexes sur le lieu de travail.
          </p>
          <p>La soumission d'une demande ne garantit pas l'approbation.</p>
        </div>

        {/* Section 3 */}
        <div className="doc-section">
          <span className="section-number">Section 3</span>
          <h2 className="section-title">Éligibilité</h2>
          <p>
            Pour demander un prêt salarial via MegaTransact, vous devez satisfaire aux critères
            d'éligibilité applicables au moment de la demande.
          </p>
          <p>Ceux-ci peuvent inclure :</p>
          <ul>
            <li>Avoir l'âge légal pour conclure un accord contraignant</li>
            <li>Détenir un compte actif avec MegaTransact le cas échéant</li>
            <li>Être employé par un employeur approuvé ou un partenaire de travail</li>
            <li>Recevoir un salaire via une structure reconnue par MegaTransact</li>
            <li>Fournir des informations et documents exacts et complets</li>
            <li>
              Satisfaire aux exigences internes d'éligibilité, opérationnelles, de risque ou de
              vérification
            </li>
          </ul>
          <p>
            MegaTransact peut mettre à jour ses critères d'éligibilité de temps à autre et peut
            approuver ou refuser les demandes à sa discrétion, sous réserve de la loi applicable.
          </p>
        </div>

        {/* Section 4 */}
        <div className="doc-section">
          <span className="section-number">Section 4</span>
          <h2 className="section-title">Demandes et approbation</h2>
          <p>Lorsque vous faites une demande de prêt salarial, MegaTransact peut examiner :</p>
          <ul>
            <li>Vos informations d'identité</li>
            <li>Vos informations d'emploi</li>
            <li>Les détails liés au salaire</li>
            <li>La capacité de remboursement</li>
            <li>Les obligations existantes sur la plateforme</li>
            <li>Les informations liées à l'employeur ou à la paie</li>
            <li>Les indicateurs de fraude, de conformité ou de risque</li>
          </ul>
          <p>MegaTransact peut :</p>
          <ul>
            <li>Approuver le montant total demandé</li>
            <li>Approuver un montant inférieur</li>
            <li>Refuser la demande</li>
            <li>Demander des informations supplémentaires avant de prendre une décision</li>
            <li>
              Retarder ou suspendre l'examen lorsque la vérification est incomplète ou que des
              préoccupations surviennent
            </li>
          </ul>
          <p>L'approbation n'est pas automatique et n'est jamais garantie.</p>
        </div>

        {/* Section 5 */}
        <div className="doc-section">
          <span className="section-number">Section 5</span>
          <h2 className="section-title">Montant et durée du prêt</h2>
          <p>Tout montant approuvé vous sera communiqué avant que vous n'acceptiez le service.</p>
          <p>Pour le service initial de prêt salarial de MegaTransact :</p>
          <ul>
            <li>La durée maximale du prêt est de 2 mois</li>
            <li>
              Le montant du prêt peut être limité par le salaire, les conditions de l'employeur,
              les règles opérationnelles, l'évaluation des risques ou la politique interne
            </li>
            <li>
              Aucun utilisateur n'a droit à un montant spécifique simplement parce qu'il a fait
              une demande antérieurement ou qu'il remplit les critères d'éligibilité de base
            </li>
          </ul>
          <p>MegaTransact peut réviser les limites de montant de prêt et les règles de service de temps à autre.</p>
        </div>

        {/* Section 6 */}
        <div className="doc-section">
          <span className="section-number">Section 6</span>
          <h2 className="section-title">Coût du service</h2>
          <p>
            Lorsqu'une demande de prêt salarial est approuvée, MegaTransact divulguera le montant
            de remboursement applicable et la structure de remboursement avant que vous
            n'acceptiez.
          </p>
          <p>Pour le modèle initial de MegaTransact :</p>
          <ul>
            <li>Le service applique des frais de 10 % par mois</li>
            <li>
              Pour une durée complète de 2 mois, cela signifie des frais totaux de 20 % sur le
              montant approuvé, sauf si une structure légale différente est expressément
              communiquée à l'utilisateur avant l'acceptation
            </li>
          </ul>
          <p>
            Vous êtes responsable de l'examen et de la compréhension du montant à rembourser
            avant d'accepter le service.
          </p>
        </div>

        {/* Section 7 */}
        <div className="doc-section">
          <span className="section-number">Section 7</span>
          <h2 className="section-title">Structure de remboursement</h2>
          <p>
            Le remboursement est lié au salaire et est censé se faire via des arrangements de
            remboursement convenus, qui peuvent inclure des déductions liées à l'employeur ou
            d'autres méthodes de recouvrement reconnues.
          </p>
          <p>Pour le modèle initial de MegaTransact :</p>
          <ul>
            <li>La durée de remboursement ne doit pas dépasser 2 mois</li>
            <li>
              Les obligations mensuelles de remboursement doivent rester dans les limites
              appliquées par la politique interne de MegaTransact et l'arrangement avec
              l'employeur concerné
            </li>
            <li>MegaTransact peut utiliser des flux de remboursement soutenus par l'employeur le cas échéant</li>
            <li>Les détails de remboursement seront présentés à l'utilisateur avant l'acceptation</li>
          </ul>
        </div>

        {/* Section 8 */}
        <div className="doc-section">
          <span className="section-number">Section 8</span>
          <h2 className="section-title">Plafond de remboursement salarial</h2>
          <p>Pour la structure initiale de prêt salarial de MegaTransact :</p>
          <ul>
            <li>
              L'obligation mensuelle de remboursement ne doit pas dépasser 42 % du salaire de
              l'utilisateur selon le cadre de prêt interne de MegaTransact
            </li>
            <li>
              Le montant du prêt approuvé peut également être limité en pratique par la politique
              de MegaTransact qui vise à maintenir la facilité totale dans une proportion gérable
              du salaire de l'utilisateur
            </li>
          </ul>
          <p>
            Ces limites internes sont appliquées pour une administration responsable du service et
            peuvent être ajustées au fil du temps.
          </p>
        </div>

        {/* Section 9 */}
        <div className="doc-section">
          <span className="section-number">Section 9</span>
          <h2 className="section-title">Participation de l'employeur</h2>
          <p>Certains arrangements de prêt salarial dépendent de la coopération de l'employeur.</p>
          <p>Lorsque l'implication de l'employeur est requise, vous reconnaissez que :</p>
          <ul>
            <li>
              MegaTransact peut confirmer votre statut d'emploi et les informations liées au
              salaire avec l'employeur
            </li>
            <li>Le remboursement peut dépendre en partie des processus de paie liés à l'employeur</li>
            <li>
              Des retards ou interruptions peuvent survenir si les processus côté employeur sont
              incomplets, en retard, inexacts ou indisponibles
            </li>
            <li>
              MegaTransact peut suspendre, retarder ou refuser le service si la participation
              de l'employeur n'est pas confirmée ou maintenue
            </li>
          </ul>
          <p>
            MegaTransact n'est pas responsable des retards de paie de l'employeur ou d'autres
            défaillances administratives du lieu de travail échappant à son contrôle raisonnable.
          </p>
        </div>

        {/* Section 10 */}
        <div className="doc-section">
          <span className="section-number">Section 10</span>
          <h2 className="section-title">Décaissement</h2>
          <p>
            Si votre demande est approuvée et que toutes les conditions requises sont remplies,
            MegaTransact peut organiser le décaissement via un ou plusieurs canaux pris en charge.
          </p>
          <p>Selon la configuration opérationnelle, cela peut inclure :</p>
          <ul>
            <li>Décaissement par argent mobile</li>
            <li>Points de collecte approuvés</li>
            <li>Autres canaux de versement approuvés introduits au fil du temps</li>
          </ul>
          <p>
            Le décaissement est considéré comme terminé une fois que le montant approuvé a été
            libéré via le processus désigné et enregistré par MegaTransact ou son partenaire de
            versement.
          </p>
        </div>

        {/* Section 11 */}
        <div className="doc-section">
          <span className="section-number">Section 11</span>
          <h2 className="section-title">Responsabilités de l'utilisateur</h2>
          <p>En utilisant le service de prêt salarial de MegaTransact, vous acceptez de :</p>
          <ul>
            <li>Fournir des informations complètes, exactes et véridiques</li>
            <li>Examiner attentivement les conditions de remboursement avant l'acceptation</li>
            <li>Utiliser les fonds à des fins légales</li>
            <li>
              Vous assurer de bien comprendre le calendrier de remboursement et le montant total
              à payer
            </li>
            <li>
              Informer MegaTransact des changements pertinents affectant votre emploi ou votre
              capacité de remboursement le cas échéant
            </li>
            <li>Coopérer avec les processus de vérification, de remboursement et de support</li>
          </ul>
        </div>

        {/* Section 12 */}
        <div className="doc-section">
          <span className="section-number">Section 12</span>
          <h2 className="section-title">Remboursements manqués ou échoués</h2>
          <p>
            Si un remboursement est manqué, retardé, annulé, bloqué ou échoue pour quelque raison
            que ce soit, MegaTransact peut prendre les mesures appropriées, y compris :
          </p>
          <ul>
            <li>Envoyer des rappels ou des avis</li>
            <li>Restreindre l'accès à certains ou à tous les services</li>
            <li>Contacter l'utilisateur via les canaux de communication approuvés</li>
            <li>
              Contacter les canaux liés à l'employeur concerné lorsque cela est légal et
              applicable
            </li>
            <li>Utiliser des mesures de recouvrement ou de collecte légales</li>
            <li>Réduire ou supprimer l'accès aux futures demandes de prêt</li>
          </ul>
          <p>Le défaut de remboursement peut affecter votre éligibilité future aux services MegaTransact.</p>
        </div>

        {/* Section 13 */}
        <div className="doc-section">
          <span className="section-number">Section 13</span>
          <h2 className="section-title">Remboursement anticipé</h2>
          <p>MegaTransact peut autoriser le remboursement anticipé lorsque cela est opérationnellement possible.</p>
          <p>Si le remboursement anticipé est permis :</p>
          <ul>
            <li>Le processus de remboursement doit suivre les procédures approuvées de MegaTransact</li>
            <li>
              Tout recalcul applicable, s'il est proposé, sera communiqué clairement
            </li>
            <li>
              Le remboursement anticipé ne donne pas automatiquement droit à une approbation
              future
            </li>
          </ul>
        </div>

        {/* Section 14 */}
        <div className="doc-section">
          <span className="section-number">Section 14</span>
          <h2 className="section-title">Suspension, refus ou annulation</h2>
          <p>
            MegaTransact peut suspendre, refuser, annuler ou inverser l'accès au prêt salarial
            lorsque cela est raisonnablement nécessaire, y compris lorsque :
          </p>
          <ul>
            <li>Les conditions d'éligibilité ne sont pas remplies</li>
            <li>Les informations ne peuvent pas être vérifiées</li>
            <li>Des informations fausses ou trompeuses sont fournies</li>
            <li>Des préoccupations de fraude, d'utilisation abusive ou de sécurité surviennent</li>
            <li>La participation de l'employeur est indisponible ou retirée</li>
            <li>Les conditions de décaissement ne sont pas satisfaites</li>
            <li>
              Des préoccupations légales, de conformité, opérationnelles ou de risque
              nécessitent une intervention
            </li>
          </ul>
          <p>MegaTransact n'est pas obligé d'approuver ou de poursuivre une demande de prêt.</p>
        </div>

        {/* Section 15 */}
        <div className="doc-section">
          <span className="section-number">Section 15</span>
          <h2 className="section-title">Pas de garantie d'accès futur</h2>
          <p>
            L'utilisation du service de prêt salarial de MegaTransact une fois ne garantit pas
            une approbation future.
          </p>
          <p>
            Chaque demande peut être évaluée séparément en fonction des informations actuelles,
            des règles de service, des conditions de l'employeur, des performances de
            remboursement antérieures et des considérations opérationnelles.
          </p>
        </div>

        {/* Section 16 */}
        <div className="doc-section">
          <span className="section-number">Section 16</span>
          <h2 className="section-title">Registres et preuves de la plateforme</h2>
          <p>MegaTransact peut conserver des registres relatifs à :</p>
          <ul>
            <li>Les demandes</li>
            <li>Les décisions d'approbation</li>
            <li>Les conditions acceptées</li>
            <li>Les calendriers de remboursement</li>
            <li>Le statut de remboursement</li>
            <li>Les confirmations liées à l'employeur</li>
            <li>Les interactions de support</li>
            <li>Les registres de décaissement</li>
            <li>Les activités de recouvrement</li>
          </ul>
          <p>
            Vous acceptez que les registres numériques, les journaux système et les registres de
            transactions de MegaTransact puissent être utilisés comme preuve de l'activité de
            service, sous réserve de la loi applicable.
          </p>
        </div>

        {/* Section 17 */}
        <div className="doc-section">
          <span className="section-number">Section 17</span>
          <h2 className="section-title">Confidentialité et utilisation des données</h2>
          <p>
            Votre utilisation du service de prêt salarial de MegaTransact est soumise à la
            politique de confidentialité de MegaTransact.
          </p>
          <p>
            En utilisant ce service, vous reconnaissez que MegaTransact peut collecter, vérifier,
            utiliser, stocker et partager les informations pertinentes de manière raisonnablement
            nécessaire pour :
          </p>
          <ul>
            <li>la vérification d'identité</li>
            <li>la confirmation d'emploi</li>
            <li>l'évaluation de l'éligibilité liée au salaire</li>
            <li>l'administration du service</li>
            <li>la gestion du remboursement</li>
            <li>la prévention de la fraude</li>
            <li>la conformité et les fins de sécurité</li>
          </ul>
        </div>

        {/* Section 18 */}
        <div className="doc-section">
          <span className="section-number">Section 18</span>
          <h2 className="section-title">Limitation de responsabilité</h2>
          <p>
            Dans toute la mesure permise par la loi, MegaTransact ne sera pas responsable des
            pertes indirectes, accessoires, consécutives, spéciales ou punitives découlant de :
          </p>
          <ul>
            <li>demandes refusées</li>
            <li>approbation retardée</li>
            <li>problèmes de paie côté employeur</li>
            <li>retards de décaissement causés par des tiers</li>
            <li>communications échouées</li>
            <li>erreurs fournies par l'utilisateur</li>
            <li>interruptions de service échappant au contrôle raisonnable de MegaTransact</li>
          </ul>
          <p>
            Rien dans les présentes conditions de prêt salarial n'exclut la responsabilité qui
            ne peut légalement être exclue.
          </p>
        </div>

        {/* Section 19 */}
        <div className="doc-section">
          <span className="section-number">Section 19</span>
          <h2 className="section-title">Modifications des présentes conditions</h2>
          <p>
            MegaTransact peut mettre à jour les présentes conditions de prêt salarial de temps à
            autre pour refléter les exigences légales, les changements de service, le
            perfectionnement des produits, les améliorations opérationnelles ou les ajustements
            de gestion des risques.
          </p>
          <p>
            Lorsque des mises à jour importantes sont effectuées, MegaTransact peut informer les
            utilisateurs via l'application, le site web, l'e-mail ou d'autres canaux appropriés.
          </p>
          <p>
            L'utilisation continue du service après l'entrée en vigueur des conditions mises à
            jour signifie que vous acceptez les conditions révisées, sauf si la loi applicable
            exige un processus différent.
          </p>
        </div>

        {/* Section 20 */}
        <div className="doc-section">
          <span className="section-number">Section 20</span>
          <h2 className="section-title">Nous contacter</h2>
          <p>
            Si vous avez des questions, des demandes ou des préoccupations concernant les
            présentes conditions de prêt salarial, veuillez contacter :
          </p>
          <div className="doc-contact-box">
            <p>
              <strong>MegaTransact</strong>
            </p>
            <p>
              <strong>E-mail :</strong>{' '}
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
            <p>
              <strong>Société :</strong> MegaBliss LTD
            </p>
            <p>
              <strong>Adresse :</strong> Bâtiment EIFUN, Avenue Kabalo n° 171, croisement Huilerie-Kabalo, Kinshasa, 4ᵉ niveau, bureau n° 45
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
